import { isEmpty } from '@witmetrics/utils/misc';
import {
  useActiveAccountLogo,
  useForm,
  useFormVersionFields,
} from '@witmetrics/data-store';
import { useFormProvider } from '@/providers/FormProvider';
import { useToggle } from '@/hooks/useToggle';
import Card from '@/components/Card';
import Note from '@/components/Note';
import { CheckIcon, CloseIcon, FormIcon, PdfIcon } from '@/icons';
import IconButton from '@/components/IconButton';
import Button from '@/components/Button';
import PdfPreviewDialog from '@/dialogs/PdfPreviewDialog';
import { classes } from './utils';

export type FormHeaderProps = {
  onSave: () => void;
  onClose: () => void;
};

export default function FormHeader({ onSave, onClose }: FormHeaderProps) {
  const logo = useActiveAccountLogo('/images/witmetrics_logo_h.png');
  const { formId, answers, versionId } = useFormProvider();
  const form = useForm(formId);
  const fields = useFormVersionFields(versionId);
  const [isPreviewOpen, togglePreview] = useToggle();

  if (!form) return null;

  return (
    <>
      {form && isPreviewOpen && (
        <PdfPreviewDialog
          logo={logo!}
          form={form}
          data={fields.map((field) => ({
            field,
            value: answers[field.id] || '',
          }))}
          onClose={() => togglePreview(false)}
        />
      )}
      <Card className={classes.card}>
        <div className={classes.infoWrapper}>
          <div className={classes.iconWrapper}>
            <FormIcon className={classes.icon} />
          </div>
          <div>
            <h1 className={classes.name}>{form.name}</h1>
            {!isEmpty(form.description) && (
              <Note className={classes.description} value={form.description!} />
            )}
          </div>
        </div>
        <div className={classes.controls}>
          <Button
            className={classes.button}
            variant="secondary"
            onClick={() => togglePreview()}>
            <PdfIcon />
            Preview
          </Button>
          <Button className={classes.button} onClick={onSave}>
            <CheckIcon />
            Save
          </Button>
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon className={classes.closeIcon} />
          </IconButton>
        </div>
      </Card>
    </>
  );
}
